export const isValidDate = (date: string): boolean => {
  if (!date || typeof date !== 'string') {
    return false
  }
  const dateString = new Date(date?.replace("'T'", 'T'))
  return !Number.isNaN(dateString.getTime())
}

export const replaceDateFormat = (date: string): string =>
  date?.replace("'T'", 'T')

export const checkIsPreorder = (preorderUntilDate?: string): boolean => {
  const preOrderDate = preorderUntilDate?.replace("'T'", 'T')

  if (preOrderDate) {
    return new Date(preOrderDate).getTime() >= new Date().getTime()
  }
  return false
}
